import './200nbeach/style';
import FormStructure from './200nbeach/form_structure';

export default FormStructure;